export default function HeroSection({className, ...props}) {

    return (

        <div className={`bg-[#F0F7FF] flex flex-col px-4 lg:px-0 lg:flex-row lg:pl-[7rem]  ${className}`}>
            <div className={"flex flex-col gap-3 my-[2rem] lg:my-[2rem] flex-[2]"}>

                <p className={"text-2xl lg:text-[2.3125rem] font-poppins font-extrabold text-black"}>
                    CEFR Checker
                </p>
                <p className={"text-sm opacity-0 lg:text-base font-normal text-gray-400"}>
                    Lorem ipsum dolor sit amet consectetur. Elit senectus est sodales a. Faucibus pellentesque tristique
                    enim magna curabitur adipiscing tempus odio sed. Donec laoreet volutpat nibh sit auctor arcu sed in
                    odio.
                </p>
            </div>
            <div className={'flex-[2]  flex justify-center items-center '}>
                <img src={"/images/crf.svg"} className={"w-[25%] "} alt={"bg"}/>


            </div>

        </div>

    )
}